import Vue from 'vue'
import VueCompositionApi from '@vue/composition-api'

// Sass
import '@/styles/main.scss'

// Post CSS
import 'postcss-object-fit-images'

// Pollyfills
import svg4everybody from 'svg4everybody'
import objectFitImages from 'object-fit-images'

// Disclosure
import DisclosureButton from './components/DisclosureButton.vue'
import DisclosureContent from './components/DisclosureContent.vue'

// Form Select
import AppForm from './components/AppForm.vue'
import AppFormClear from './components/AppFormClear.vue'
import AppFormSubmit from './components/AppFormSubmit.vue'
import AppFormSelect from './components/AppFormSelect.vue'

// Events
import AppEvents from './components/AppEvents.vue'
import AppEventsButton from './components/AppEventsButton.vue'

// Product Carousel
import ProductCarousel from './components/ProductCarousel.vue'

// Nav Toggle
import NavToggle from './components/NavToggle.vue'

// App Filter
import AppFilter from './components/AppFilter.vue'
import AppFilterItem from './components/AppFilterItem.vue'
import AppFilterSelect from './components/AppFilterSelect.vue'
import AppFilterButton from './components/AppFilterButton.vue'

// App Video Reveal
import AppVideoReveal from './components/AppVideoReveal.vue'

// App Background Video
import AppBackgroundVideo from './components/AppBackgroundVideo.vue'

// Modal
import AppModal from './components/AppModal.vue'

// Intersection Observer Polyfill
import 'intersection-observer'

// Animate on Scroll
import AOS from 'aos'

// Parallaxy
import AppParallax from 'vue-parallaxy'

Vue.config.productionTip = false

Vue.use(VueCompositionApi)

svg4everybody()
objectFitImages()

AOS.init({
  offset: 100,
  duration: 500,
})

const Components = {
  DisclosureButton,
  DisclosureContent,
  AppForm,
  AppFormClear,
  AppFormSubmit,
  AppFormSelect,
  AppEvents,
  AppEventsButton,
  ProductCarousel,
  NavToggle,
  AppFilter,
  AppFilterItem,
  AppFilterSelect,
  AppFilterButton,
  AppParallax,
  AppVideoReveal,
  AppBackgroundVideo,
  AppModal,
}

Object.keys(Components).forEach(componentName => {
  Vue.component(componentName, Components[componentName])
})


const STORAGE_KEY = "mujen.ageCheck";
const appStorage = {
  fetch: () => {
    const itemStr = localStorage.getItem(STORAGE_KEY);

    if (!itemStr) {
      return null;
    }

    const item = JSON.parse(itemStr);
    const now = new Date();

    if (now.getTime() > item.expiry) {
      localStorage.removeItem(STORAGE_KEY);
      return null;
    }
    return item.value;
  },
  save: (value, ttl) => {
    const now = new Date();

    const item = {
      value: value,
      expiry: now.getTime() + ttl
    };

    localStorage.setItem(STORAGE_KEY, JSON.stringify(item));
  }
};

const app = new Vue({
  data() {
    return { show: appStorage.fetch() };
  },
  watch: {
    show(data) {
      data && appStorage.save(true, 6.048e+8); // 1 week in milliseconds
    }
  },
  methods: {
    ...appStorage
  },
})

app.$mount('#app')
